import React, { useEffect, useState } from "react";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import { useHistory } from "react-router-dom";
import Grid from "@visa/vds/grid";
import Row from "@visa/vds/row";
import Col from "@visa/vds/col";
import Typography from "@visa/vds/typography";
import ButtonGroup from "@visa/vds/button-group";
import ButtonText from "@visa/vds/button-text";
import MCSOverlayLoading from "../../components/MCSOverlayLoading";
import DafUploadFileTable from "./Components/DafUploadFileTable";
import { GlobalAlertContext } from "../../context/GlobalAlertContext";
import { DafUploadApi } from "../../services/daf.upload.service";
import { DafUploadRoutes } from "../../_constants/PageRoutes";
import { PageHelper } from "../../_helpers/PageHelper";
import { FileHelper } from '../../_helpers/FileHelper';
import { DafHelper } from '../../_helpers/DafHelper';

const ManageDafUploadFile = () => {
  const history = useHistory();
  const { promiseInProgress } = usePromiseTracker();
  const [error, setError] = useState(null);
  const [tableData, setTableData] = useState(null);
  const [totalPage, setTotalPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const pageSize = 10;
  const sortBy = "CreatedOn";
  const desc = true;
  const defaultFilter = {
    search: "",
  };

  const returnToUploadFilePage = () => {
    history.push(DafUploadRoutes.DAF_UPLOAD);
  };

  const handleClickAction = (item) => {
    history.push({
      pathname: DafUploadRoutes.DAF_UPLOAD_REQUEST,
      state: {
        dafUpload: item,
      },
    });
  };

  const handleDownloadProcessFile =(item)=>{
    let id = item.id;
    trackPromise(
      DafUploadApi.downloadProcessResultFile(id)
        .then((response) => {
          FileHelper.DownloadFile(response);
        })
        .catch((error) => {
          setError(error)
        })
    );
  };

  const handleDownloadErrorLog = async (item, alertObj) => {
    await DafHelper.DownloadErrorLog(item.id, alertObj);
  };

  const fetchData = async (page, sortBy, desc, filter, alertObj) => {
    let skipCount = PageHelper.GetSkipCount(pageSize, page);
    trackPromise(
      DafUploadApi.getDafUploadList(skipCount, sortBy, desc, pageSize, filter)
        .then((result) => {
          var response = result.data;
          setTableData(response.items);
          setTotalCount(response.totalCount);
          setTotalPage(
            PageHelper.GetTotalCountToPages(pageSize, response.totalCount)
          );
        })
        .catch((error) => {
          if (alertObj) alertObj.setErrorMessage(error.message);
          else setError(error);
        })
    );
  };

  useEffect(() => {
    fetchData(1, sortBy, desc, defaultFilter);
  }, []);

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <>
      {promiseInProgress && <MCSOverlayLoading></MCSOverlayLoading>}
      <GlobalAlertContext.Consumer>
        {(alertObj) => (
          <>
            <Grid>
              <Row>
                <Col>
                  <Typography tag="h1">Uploaded Files</Typography>
                  <ButtonGroup direction="right">
                    <ButtonText
                      colorScheme="primary"
                      onClick={returnToUploadFilePage}
                    >
                      Upload new file
                    </ButtonText>
                  </ButtonGroup>
                </Col>
              </Row>
              <Row>
                <DafUploadFileTable
                  alertObj={alertObj}
                  fetchData={fetchData}
                  tableData={tableData}
                  pageSize={pageSize}
                  totalCount={totalCount}
                  totalPage={totalPage}
                  defaultSortBy={sortBy}
                  defaultDesc={desc}
                  defaultFilter={defaultFilter}
                  handleDownloadProcessFile = {handleDownloadProcessFile}
                  handleDownloadErrorLog = {handleDownloadErrorLog}
                  handleClickAction={handleClickAction}
                />
              </Row>
            </Grid>
          </>
        )}
      </GlobalAlertContext.Consumer>
    </>
  );
};
export default ManageDafUploadFile;
